import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProductList from './components/ProductList';
import Login from './pages/Login';
import ForgotPasswordOtp from './pages/ForgotPasswordOtp'
import Register from './pages/Register';
import PostAd from './pages/PostAd';
import MyListings from './pages/MyListings';
import ProductDetails from './pages/ProductDetails';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import VerifyOtp from './pages/VerifyOtp';
import AboutUs from './pages/AboutUs';
import SafetyGuidelines from './pages/SafetyGuidelines';
import { getStoredAuth, clearAuthSession } from './authStorage';
import { apiUrl } from './api';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const navContainerRef = useRef(null);
  
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState({
    city: '',
    locality: '',
    keyword: '',
    minPrice: '',
    maxPrice: '',
    category: ''
  });
  const [activeCategory, setActiveCategory] = useState('');
  const [token, setToken] = useState(() => getStoredAuth().token);

const categories = [
  { label: 'All', value: '' },
  { label: 'Mobile Phones', value: '1' },
  { label: 'Electronics', value: '2' },
  { label: 'Cars', value: '3' },
  { label: 'Bikes', value: '4' },
  { label: 'Automotive Accessories', value: '5' },
  { label: 'Furniture', value: '6' },
  { label: 'Rent: Houses & flats', value: '7' },
  { label: 'Buy: Houses & flats', value: '8' },
  { label: 'Tools & Home Improvement', value: '9' },
  { label: 'Books', value: '10' },
  { label: 'Jewelry & Watches', value: '11' },
  { label: 'Clothing', value: '12' },
  { label: 'Garden & Outdoors', value: '13' },
  { label: 'Sports', value: '14' },
  { label: 'Musical Instruments', value: '15' },
  { label: 'Art & Craft Supplies', value: '16' },
  { label: 'Office & Stationery', value: '17' },
  { label: 'Home & Kitchen', value: '18' }
];

  const fetchProducts = useCallback(async () => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });

    try {
      const response = await fetch(apiUrl(`/api/products?${params}`));
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }, [filters]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const nextFilters = {
      city: params.get('city') || '',
      locality: params.get('locality') || '',
      keyword: params.get('keyword') || '',
      minPrice: params.get('minPrice') || '',
      maxPrice: params.get('maxPrice') || '',
      category: params.get('category') || ''
    };

    setFilters(nextFilters);
    setActiveCategory(nextFilters.category);
  }, [location.search]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const handleCategorySelect = (categoryValue, event) => {
    setActiveCategory(categoryValue);
    
    if (event?.target) {
      event.target.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }

    const params = new URLSearchParams(location.pathname === '/' ? location.search : '');
    if (categoryValue) {
      params.set('category', categoryValue);
    } else {
      params.delete('category');
    }

    setFilters(prev => ({ ...prev, category: categoryValue }));
    navigate({ pathname: '/', search: params.toString() ? `?${params.toString()}` : '' });
  };

  const handleLogout = () => {
    clearAuthSession();
    setToken(null);
  };

  return (
    <div className="App">
      <Navbar token={token} onLogout={handleLogout} />
      
      {/* Category Bar */}
      <div className="category-nav-wrapper">
        <div className="category-nav">
          <div className="category-nav-inner" ref={navContainerRef}>
            {categories.map((category) => (
              <button
                key={category.value || 'all'}
                className={`category-pill ${activeCategory === category.value ? 'active' : ''}`}
                onClick={(e) => handleCategorySelect(category.value, e)}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPasswordOtp />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/post" element={<PostAd token={token} />} />
          <Route path="/my-listings" element={<MyListings token={token} />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/safety" element={<SafetyGuidelines />} />
          <Route path="/" element={<ProductList products={products} />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;